module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    attrs: {
      "id": "app"
    },
    on: {
      "swipeleft": function($event) {
        _vm.toggleSwipeSidebar('left')
      },
      "swiperight": function($event) {
        _vm.toggleSwipeSidebar('right')
      }
    }
  }, [_c('sidebar', {
    attrs: {
      "show": _vm.selectedLeftSidebar,
      "side": "left"
    }
  }, [_c('div', {
    attrs: {
      "id": "left-menu"
    }
  }, [_c('router-link', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "to": "/ideas/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": "/static/logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-block"
  }, [_c('div', {
    staticClass: "header-search"
  }, [_c('button', {
    staticClass: "button-search",
    on: {
      "click": function($event) {
        _vm.goToSearch(_vm.enteredSearchString)
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "searsh",
    attrs: {
      "type": "search",
      "name": "search",
      "placeholder": "Начать поиск"
    },
    on: {
      "blur": function($event) {
        _vm.enterSearchString($event.target.value)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.goToSearch($event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mobi-height"
  }, [_c('router-link', {
    staticClass: "button button-create-idea",
    attrs: {
      "to": {
        name: 'idea-create'
      },
      "tag": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.offSidebar($event)
      }
    }
  }, [_vm._v("\n                    Предложить свою идею\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-buttons-group"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'ideas'
      },
      "active-class": "is-active",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.offSidebar($event)
      }
    }
  }, [_vm._v("\n                        На голосовании\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.total))])]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'inprocess-ideas'
      },
      "active-class": "is-active"
    },
    nativeOn: {
      "click": function($event) {
        _vm.offSidebar($event)
      }
    }
  }, [_vm._v("\n                        В работе\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.inprocess))])]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'completed-ideas'
      },
      "active-class": "is-active"
    },
    nativeOn: {
      "click": function($event) {
        _vm.offSidebar($event)
      }
    }
  }, [_vm._v("\n                        Реализованные\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.completed))])]), _vm._v(" "), (_vm.isLogged) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'my-ideas'
      },
      "active-class": "is-active"
    },
    nativeOn: {
      "click": function($event) {
        _vm.offSidebar($event)
      }
    }
  }, [_vm._v("\n                        Мои идеи\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.my))])]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'starred-ideas'
      },
      "active-class": "is-active"
    }
  }, [_vm._v("\n                        Избранные\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.starred))])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'canceled-ideas'
      },
      "active-class": "is-active"
    },
    nativeOn: {
      "click": function($event) {
        _vm.offSidebar($event)
      }
    }
  }, [_vm._v("\n                        Отклонённые\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.canceled))])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'moderation-ideas'
      },
      "active-class": "is-active"
    },
    nativeOn: {
      "click": function($event) {
        _vm.offSidebar($event)
      }
    }
  }, [_vm._v("\n                        На модерации\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.moderation))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ideus-mibile"
  })], 1), _vm._v(" "), _c('user-panel', {
    staticClass: "user-menu"
  })], 1)]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.selectedRightSidebar,
      "side": "right"
    }
  }, [_c('header', {
    attrs: {
      "id": "right-menu"
    }
  }, [_c('div', {
    staticClass: "filter-category"
  }, [_c('ul', {
    staticClass: "filter-menu"
  }, [_c('h2', {
    staticClass: "title-filter"
  }, [_vm._v("\n                        Фильтр по категориям\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "filter-item all-select",
    class: {
      'active-item': _vm.isCatFilterEmpty()
    },
    on: {
      "click": function($event) {
        _vm.setCategory()
      }
    }
  }, [_c('span', {
    staticClass: "icon-form"
  }), _vm._v("Все\n                    ")]), _vm._v(" "), _vm._l((_vm.rootCategories), function(cat) {
    return _c('li', {
      staticClass: "filter-item",
      class: {
        'active-item': _vm.isCatSelected(cat.id)
      },
      on: {
        "click": function($event) {
          _vm.toggleCategory(cat)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form"
    }), _vm._v("\n                        " + _vm._s(cat.title) + " - " + _vm._s(_vm.counters.categories ? (_vm.counters.categories[cat.id] || 0) : '') + "\n\n                        "), (_vm.categories[cat.id]) ? _c('ul', {
      staticClass: "sec-menu"
    }, _vm._l((_vm.categories[cat.id]), function(child) {
      return _c('li', {
        staticClass: "filter-item",
        class: {
          'active-item': _vm.isCatSelected(child.id)
        },
        on: {
          "click": function($event) {
            _vm.toggleCategory(child)
          }
        }
      }, [_c('span', {
        staticClass: "icon-form"
      }), _vm._v("\n                                " + _vm._s(child.title) + " - " + _vm._s(_vm.counters.categories ? (_vm.counters.categories[cat.id] || 0) : '') + "\n                            ")])
    })) : _vm._e()])
  })], 2)])])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "panel"
    }
  }, [_c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/ideas/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": "/static/logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-block",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "header-search"
  }, [_c('button', {
    staticClass: "button-search",
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "searsh",
    attrs: {
      "type": "search",
      "name": "search",
      "placeholder": "Начать поиск"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "click": function($event) {
        _vm.toggleSearch(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showSearch) ? _c('div', {
    staticClass: "block-search"
  }, [(_vm.searchResults.byTitle && _vm.searchResults.byTitle.length) ? _c('div', {
    staticClass: "similar-title"
  }, [_c('p', {
    staticClass: "similar-theme"
  }, [_vm._v("Похожие темы")]), _vm._v(" "), _vm._l((_vm.searchResults.byTitle), function(idea) {
    return _c('router-link', {
      staticClass: "similar-block",
      attrs: {
        "to": {
          name: 'idea',
          params: {
            id: idea.id
          }
        },
        "tag": "div"
      }
    }, [_c('span', {
      staticClass: "title-similar"
    }, [_c('a', [_vm._v(_vm._s(idea.title))])]), _vm._v(" "), _c('span', {
      staticClass: "button-like cabinet-buttons"
    }, [_c('i', {
      staticClass: "ti-thumb-up"
    }), _vm._v(" " + _vm._s(idea.likes) + "\n                                ")]), _vm._v(" "), _c('span', {
      staticClass: "button-dislike cabinet-buttons"
    }, [_c('i', {
      staticClass: "ti-thumb-down"
    }), _vm._v(" " + _vm._s(idea.dislikes) + "\n                                ")]), _vm._v(" "), _c('p', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(_vm.dateNoTime(idea.created)))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.searchResults.byDesc && _vm.searchResults.byDesc.length) ? _c('div', {
    staticClass: "similar-text"
  }, [_c('p', {
    staticClass: "similar-theme"
  }, [_vm._v("Упоминания в тексте")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.searchResults.byDesc), function(idea) {
    return _c('router-link', {
      staticClass: "similar-text-content",
      attrs: {
        "to": {
          name: 'idea',
          params: {
            id: idea.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(idea.title))]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm._f("striphtml")(idea.description)))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.searchResults.byTitle && _vm.searchResults.byDesc && !_vm.searchResults.byTitle.length && !_vm.searchResults.byDesc.length) ? _c('div', [_c('p', [_c('em', [_vm._v("Ничего не найдено")])])]) : _vm._e(), _vm._v(" "), (_vm.searchResults.byTitle && _vm.searchResults.byDesc && _vm.searchResults.byTitle.length && _vm.searchResults.byDesc.length) ? _c('span', {
    staticClass: "bautton-similar"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'search',
        params: {
          term: _vm.search
        }
      }
    }
  }, [_vm._v("Смотреть все результаты")])], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mobi-height"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": {
        name: 'idea-create'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                        Предложить свою идею\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ideus-mibile"
  })], 1), _vm._v(" "), _c('user-panel', {
    staticClass: "user-menu"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "header-mobile"
  }, [_c('span', {
    staticClass: "menu-sandwich",
    on: {
      "click": function($event) {
        _vm.selectedLeftSidebar = !_vm.selectedLeftSidebar
      }
    }
  }, [_c('span', {
    staticClass: "sandwich"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "widgets-ideas-button all-ideas",
    attrs: {
      "to": "/ideas/"
    }
  }, [_vm._v("Все идеи")]), _vm._v(" "), _c('span', {
    staticClass: "set",
    on: {
      "click": function($event) {
        _vm.selectedRightSidebar = !_vm.selectedRightSidebar
      }
    }
  }, [_c('i', {
    staticClass: "ti-filter",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('main', {
    staticClass: "main",
    on: {
      "click": function($event) {
        _vm.toggleSearch(false);
        _vm.offSidebar()
      }
    }
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('spinner', {
    attrs: {
      "size": "large",
      "message": "Загрузка..."
    }
  }), _vm._v(" "), _c('informator', {
    attrs: {
      "show": _vm.showInfo
    }
  }), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "container footer-block"
  }, [_c('p', {
    staticClass: "footer-copyright"
  }, [_vm._v("© 2017 «Платформа LP». Все права защищены.")]), _vm._v(" "), _c('p', {
    staticClass: "footer-socials"
  }, [_c('a', {
    staticClass: "socials-link",
    attrs: {
      "href": "https://vk.com/platformalp",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/socials/vkontakte@2x.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socials-link",
    attrs: {
      "href": "https://www.facebook.com/weloveplatformalp/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/socials/facebook@2x.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socials-link",
    attrs: {
      "href": "https://t.me/platformalp",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/socials/telegram@2x.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socials-link",
    attrs: {
      "href": "https://www.instagram.com/platforma_lp/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/socials/instagram@2x.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socials-link",
    attrs: {
      "href": "https://www.youtube.com/channel/UCbqmPnagvp3CF43XnlsQEqw",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/socials/youtube@2x.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socials-link",
    attrs: {
      "href": "https://plus.google.com/u/1/114447428233574103343",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/socials/googleplus@2x.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socials-link",
    attrs: {
      "href": "https://twitter.com/platformalp",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/socials/twitter@2x.png"
    }
  })])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 107
// module chunks = 0